import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import axios from 'axios'

const SignUpForm = () => {

  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [password2, setPassword2] = useState("")
  const [errText, setErrText] = useState("")
  const url = process.env.REACT_APP_URL

  // console.log(url)
  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== password2){
      setErrText("Passwords need to be identical.")
      return 
    } else {
      const data = {
        firstName,
        lastName,
        email,
        password,
      }
      axios.post(url + "/register" , data).then(console.log)

    }

  }

  return (
    <Form onSubmit={(e) => handleSubmit(e)} className='pt-4 w-100 m-auto'>

      <Form.Group className="mb-3" controlId="formFirstName">
        <Form.Label>First Name</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setFirstName(e.target.value)} required type="first_name" placeholder="Enter Name" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formLastName">
        <Form.Label>Surname</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setLastName(e.target.value)} required type="last_name" placeholder="Enter Surname" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formEmail">
        <Form.Label>Email Address</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setEmail(e.target.value)} required type="email" placeholder="Enter Email" />
        <Form.Text className="text-muted">
            We'll never share your email with anyone else.
        </Form.Text>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setPassword(e.target.value)} required type="password" placeholder="" />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formPassword2">
        <Form.Label>Retype Password</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setPassword2(e.target.value)} required type="password" placeholder="" />
      </Form.Group>

      <p style={{minHeight:"30px"}} className='text-danger' id="sign-in-error-text">{errText}</p>
      <Button disabled={firstName===""||email===""||lastName===""||password===""||password2===""} className='py-2 w-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
        Submit
      </Button>
    </Form>
  )
}

export default SignUpForm